import React from "react";
import { Pressable } from "react-native";

import { SearchIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  onPress?: () => void;
  title: string;
  values: {
    value: string | null;
    placeholder: string;
  }[];
};

export const EventsFilterBar = ({ onPress, title, values }: Props) => {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={title}
    >
      <HStack
        px={5}
        py={4}
        gap={4}
        borderRadius="4"
        borderWidth={1.5}
        borderColor="surface-dividers"
        alignItems="center"
        shadowColor="black"
        shadowOpacity={0.06}
        shadowOffset={{ width: 0, height: 8 }}
        shadowRadius={16}
        maxHeight={68}
      >
        <SearchIcon />
        <VStack gap={".5"}>
          <Text variant="mainBaseMedium">{title}</Text>
          <HStack gap={".5"} alignItems="center" flexWrap="wrap">
            {values.map(({ value, placeholder }, index) => {
              const renderValue = value !== null ? value : placeholder;
              return (
                <React.Fragment key={index}>
                  {index !== 0 ? <Text color="text-secondary">∙</Text> : null}
                  <Text
                    variant="mainTiny"
                    color={value !== null ? "text-primary" : "text-secondary"}
                  >
                    {renderValue}
                  </Text>
                </React.Fragment>
              );
            })}
          </HStack>
        </VStack>
      </HStack>
    </Pressable>
  );
};
